<template>
<div class="chapter">
<div class="inner_page">
<p class="vexth">THE MOON LOOKS DOWN</p>
<p class="vext1">I climb alone to my secret place</p>
<p class="vext">And gaze from my rocky perch</p>
<p class="vext3">To commune with the moon.</p>
<p class="vext1">I ask that circling silvery stone the</p>
<p class="vext">Questions that perplex me so.</p>
<p class="vext3">Can the moon on high tell me why…</p>
<p class="vext1">Why dark souls aflame with hate</p>
<p class="vext">Ignite the fires that terrify me,</p>
<p class="vext">Why those whom once I trusted</p>
<p class="vext3">Plot to harm the ones I love.</p>
<p class="vext1">I look with hope into the night</p>
<p class="vext">And the moon looks down.</p>
<p class="vext">How absurd! It says not a word.</p>
<p class="vexts">—F.S.I.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MoonLookedDown_epig-1.vue?38bdeb2c